export default {
  caret: "veCaret",
  selectionStart: "veSelectionLayerStart",
  selectionEnd: "veSelectionLayerEnd"
};
